import React, { PropTypes } from 'react';

const LOGO = "https://www.crowdspring.com/blog/wp-content/uploads/2020/03/logo-pink-blue.png";

const RelatedContent = ({ title, content, cta, hideLogo }) => {
  return (
    <section className="block block-related-content">
      <div className="row align-center">
        <div className="columns small-16 large-10">
          <div className="box">
            <label>Tell me more!</label>
            <h2>{ title }</h2>
            <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
            <a className="cta" href={cta.url} target="_blank">
              { cta.label } <i className="fa fa-long-arrow-right" />
            </a>
            { !hideLogo && <img className="logo" src={LOGO} /> }
          </div>
        </div>
      </div>
    </section>
  );
}

RelatedContent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  cta: PropTypes.object.isRequired,
  hideLogo: PropTypes.bool,
};

export default RelatedContent;
